document.addEventListener('DOMContentLoaded', function () {

  const swiper = new Swiper('.custom-slider', {

    loop: true,

    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },

    speed: 700,

    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }

  });

  // Make slides clickable
  document.addEventListener('click', function (e) {

    // If the user clicked the button, let the button work normally
    if (e.target.closest('.hero-button')) {
      return;
    }

    // Find the slide that was clicked
    const slide = e.target.closest('.swiper-slide');

    if (!slide) return;

    const link = slide.dataset.link;

    if (link) {
      window.location.href = link;
    }

  });

});